import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, Typography } from '@occc-app/design-system';

import { MarketingContentFormValuesPaths } from './types';

type AdditionalInformationDesignSectionProps = {
  showSurgeonGeneralsWarning: boolean;
};

const formNamePrefix = 'marketingContent';

export const AdditionalInformationDesignSection = ({
  showSurgeonGeneralsWarning,
}: AdditionalInformationDesignSectionProps) => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Additional Information</Typography>
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.terms` satisfies MarketingContentFormValuesPaths}
          label='Terms'
          multiline
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.termsUrl` satisfies MarketingContentFormValuesPaths}
          label='Terms URL'
        />
      </Grid>
      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.disclaimer` satisfies MarketingContentFormValuesPaths}
          label='Disclaimer'
          multiline
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          name={`${formNamePrefix}.disclaimerUrl` satisfies MarketingContentFormValuesPaths}
          label='Disclaimer URL'
        />
      </Grid>

      {showSurgeonGeneralsWarning && (
        <Grid xs={12} sm={6}>
          <TextField
            name={
              `${formNamePrefix}.surgeonGeneralsWarning` satisfies MarketingContentFormValuesPaths
            }
            label="Surgeon General's Warning"
            multiline
          />
        </Grid>
      )}
    </Grid>
  );
};
